export const locale = {
    lang: 'tr',
    data: {
      'ALERTS':{
        'OK':'OK'
      },
      'FOCUS':{
        'GRUPOS':{
          'ADMIN': 'Grup yöneticisi',
          'CREAR': 'Grup oluştur',
          'EDITAR': 'Grubu düzenle',
          'APLICAR': 'Uygulamak',
          'NAME':'Grup ismi',
          'DESCRIPCION': 'Açıklama',
          'FILTROS': 'Filtreler',
          'ACCION': 'Hareketler',
          'EDIT': 'Düzenle',
          'DELETE': 'Sil'
        },
        'CREAR': {
          'DATO': 'Grup verileri',
          'NAME': 'Grup ismi',
          'DESCRIPCION': 'Grup açıklaması',
          'FILTROS': 'Filtreler',
          'FILSELEC': 'Seçilen filtreler',
          'COUNTRY': 'Ülke',
          'CARGO': 'Konum veya işlev',
          'ANTIG': 'Eskilik',
          'GENDER': 'Cinsiyet'
        },
        'REACTIVOS': {
          'SIN': 'Henüz ifade seçimi yapmadınız',
          'STEPS': {
            '1': {
                'TITULO': 'İfadelerin seçimi',
                'DISPONIBLES': 'Kullanılabilir şablonlar: ',
                'LISTADO': {
                  'TITULO': 'Anketin oluşturulmasını istediğiniz bir liste için ifadeleri seçin',
                  'SUBTITULO': 'İfade listesini göstermek için listeden bir şablon seçin',
                  'PICKEDTITU': 'Şablon için bildirim listesi: ',
                  'PICKEDTOT': 'Mevcut ifadeler: ',
                  'PICKEDNUM': 'Seçilen ifadeler: ',
                }
            },
            '2': {
                'TITULO': 'Çeviriler'
            },
            '3': {
                'TITULO': 'Previsualización',
                'TEXTOS': {
                  'es': {
                    'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                    'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                    'BOTONES': {
                      '0': 'Casi siempre es falso',
                      '1': 'Frecuentemente es falso',
                      '2': 'A veces es falso / A veces es verdad',
                      '3': 'Frecuentemente es verdad',
                      '4': 'Casi siempre es verdad'
                    }
                  },
                  'en': {
                    'EMPRESA': 'Organization Perspective',
                    'AREA': 'Workgroup Perspective',
                    'BOTONES': {
                      '0': 'It is almost always false',
                      '1': 'It is often false',
                      '2': 'Sometimes it´s fake / Sometimes it´s true',
                      '3': 'It is often true',
                      '4': 'It is almost always true'
                    }
                  },
                  'pt': {
                    'EMPRESA': 'Perspectiva da organização',
                    'AREA': 'Perspectiva do grupo de trabalho',
                    'BOTONES': {
                      '0': 'Quase sempre é falso',
                      '1': 'É frequentemente falso',
                      '2': 'Às vezes é falso / às vezes é verdade',
                      '3': 'É frequentemente verdade',
                      '4': 'Quase sempre é verdade'
                    }
                  },
                }
              }
          }
        }
      },
      'CERTIFICAR': {
        'IDIOMAS': {
          'ELEGIR': 'Seçiniz',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'Adım tamamlandı'
          },
          'MENSAJES':{
            'ADDLANG': 'Dil eklendi',
            'NOADITIONAL': 'Ek dil seçimi yapılmamıştır',
            'ERRORADD': 'Dil seçimi yapılırken bir hata oluştu ',
            'LANGDEL': 'Bu dil silindi',
            'NOADITIONALDEL': 'Seçim ek dil uygulanmadan iptal edildi',
            'ERRORDEL': 'Dil silinirken bir hata oluştu ',
            'MAINPICKED': 'Bu anket için ana dil seçilmiştir..<br><br>Değiştirmek için, seçilmiş olan dili kaldırdıktan sonra yenisini ekleyin.'
          },
          'CARD1': {
            'TITULO': 'Ana dil',
            'ACCION': {
              'PRE': 'Ana dili seçmediniz',
              'POST': 'Aşağıdaki dili seçtiniz :'
            },
            'MODAL': {
              'TITULO': 'Ana dili seçin',
              'ACCION': 'Anketin ana dili?',
              'PLACELISTA': 'Dili seçin',
              'BOTONES': {
                'BACK': 'Geri',
                'OK': 'Hazır'
              }
            }
          },
          'CARD2': {
            'TITULO': 'Ek diller',
            'ACCION': {
              'PRE': 'Herhangi bir ek dil seçmediniz',
              'SINADIC': 'Anket ek dil içermeyecek',
              'POST': 'Aşağıdaki dilleri seçtiniz :'
            },
            'MODAL': {
              'TITULO': 'Ek dilleri seçiniz',
              'ACCION': 'Anketinize hangi ek dilleri dahil etmek istiyorsunuz?',
              'BOTONES': {
                'BACK': 'Geri',
                'OK': 'Hazır'
              }
            }
          }
        },
        'NPS': {
          'CONFIGURE_QUESTION': 'NPS\'yi görüntülemek için buraya basın',
          'ADD': 'Yeni bir soru oluştur',
          'QUESTIONUPDATEDOK': 'NPS başarıyla güncellendi',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'TABS':{
            'TAB1': 'NPS',
            'TAB2': 'Çeviri',
            'TAB3': 'Ön izleme',
          }
        },

        'REACTIVOS': {
          'CONFIGURE_QUESTION': 'Soruyu düzenlemek için tıklayınız',
          'ADD': 'Yeni bir soru oluştur',
          'QUESTIONUPDATEDOK': 'Soru başarıyla güncellendi',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'TABS':{
            'TAB1': 'Sorular',
            'TAB2': 'Çeviri',
            'TAB3': 'Ön izleme',
          }
        },
        'CONTROL': {
          'CONFIGURE_QUESTION': 'Kontrol sorusunu görüntülemek için buraya tıklayın',
          'ADD': 'Yeni bir soru oluştur',
          'QUESTIONUPDATEDOK': 'Kontrol sorusu başarıyla güncellendi',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',

            'DONE': 'İşlem tamamlandı'
          },
          'TABS': {
            'TAB1': 'Kontrol sorusu',
            'TAB2': 'Çeviri',
            'TAB3': 'Ön izleme',
          }
        },
        'DEMOGRAFICOS': {
          'NOINFO':'Bilgi bulunmamaktadır',
          'TAB1': 'Demografik',
          'TAB2': 'Çevirmek',
          'TAB3': 'Ön izleme',
          'COMPLETAR_PASO': 'Tamamlandı adım',
          'PASO_COMPLETADO': 'Adım tamamlandı',
          'SELECT': 'Seçiniz',
          'BTN_DEMOGRAFICOS': 'Kabul etmek',
          'OPTION_SURVEY': 'anket',
          'OPTION_EXCEL': 'Excel',
          'OPTION_AMBOS': 'Her ikisi de',
          'CLAVE': 'Satır anahtarı',
          'RESPONSE_NOT_ADDED': 'açık bir soruya cevap ekleyemezsin',
          'CONFIGURE_QUESTION': 'Soruyu görüntülemek için buraya tıklayın',
          'QUESTION': 'Soru',
          'OPCIONES_RESPUESTA': 'Yanıt seçenekleri',
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'EXPANSION':{
            'Work Responsability' : 'Çalışma Sorumluluğu',
            'Trust Level' : 'Güven seviyesi',
            'Innovation' : 'Yenilik',
            'Disabilities' : 'Engelliler,',
            'Ethnic Group' : 'Ethnic Group',
            'Personal Responsabilities' : 'Kişisel Sorumluluklar ',
            'Gender' : 'Cinsiyet',
            'Work Location' : 'İş yeri',
            'Travel' : 'Seyahat',
            'Living Location' : 'Yaşayan Yer',
            'Marital Status' : 'Medeni hal',
            'Home Type' : 'Ev Tipi',
            'Home Location' : 'Ev konumu',
            'Home Status' : 'Ev Durumu',
            'Transport' : 'Taşıma',
            'Sports' : 'Spor',
            'Weight' : 'Ağırlık',
            'Sleep' : 'Uyku',
            'Home Office' : 'Ev Ofis',
            'Languages' : 'Diller',
            'Work Experience' : 'İş Deneyimi',
            'Social Networks' : 'Sosyal Ağlar',
            'Employ Opportunities' : 'İş Fırsatları',
            'Inspiration' : 'İlham',
            'Meetings' : 'Toplantılar',
            'Tenure' : 'Tenure',
            'Clave': 'Anahtar',
            'Ege': 'nesil',
            'Work Status': 'Çalışma Durumu',
            'Education': 'Eğitim',
            'Hierarchical Level': 'Hiyerarşik Seviye',
            'Confidence Decisions': 'Güven Kararları',
            'Work Innovation': 'İş Yeniliği',
            'Belong': 'Ait',
            'Converse Performance': 'Converse Performans',
            'Work Years':'Çalışma Yılları',
            'Generation':'Nesil',
            'Confidence In Decisions': 'Kararlarda Güven',
            'Develop New Things': 'Yeni Şeyler Geliştir',
            'Reason To Stay':'Kalma Nedeni',
            'Age':'yaş',
            'Type Of Job':'İşin Türü',
            'Minoritate':'Minoritate',
            'Sindicat':'Sindicat',
            //TURQUIA//
            'Confidence':'Güven',
            'Opportunities':'Fırsatlar',
            'Managerial Level':'Yönetici seviyesinde',
            'Years Of Service':'Hizmet Yılı',
            'Ethnic':'Etnik',
            //CAYC//
            'Hierarchical Leve':'Hiyerarşik Seviye',
            'Disability':'sakatlık',
            'Responsibility':'sorumluluk',
            'LGBT':'LGBT',
            //ESPAÑA
            'Recommendation':'Öneri',
            'Seniority':'Kıdem',
            'Contracting modality':'Sözleşme usulü',
            'Working':'Çalışma',
         }
        },
        'FORALL': {
          'MSJ_PRACTICEREGISTERED': 'Uygulama başarıyla kaydedildi',
          'MSJ_DESCRIPTIONREGISTERED': 'Açıklama başarıyla kaydedildi',
          'MSJ_TRANSLATEREGISTERED': 'Uygulama başarıyla çevrildi',///
          'MSJ_DESCRIPTIONTRANSLATED': 'Açıklama başarıyla çevrildi',///
          'QUESTIONUPDATEDOK': 'Soru başarıyla güncellendi',
          'QUESTIONUPDATEDFAIL': 'Hata, geçerli bir soru ekle',
          'RESPONSEUPDATEDOK': 'Yanıt başarıyla güncellendi',
          'RESPONSEUPDATEDFAIL': 'Hata, geçerli bir cevap metni ekleyin',
          'TRANSLATEDOK': 'Soru çeviri başarılı bir şekilde kaydedildi',
          'INSERTTRANSLATE': 'Lütfen çeviriyi ekle',
          'OPTIONTRANSLATED': 'Seçenek çeviri başarılı bir şekilde kaydedildi',
          'INSERTOPTIONTRANSLATE': 'Lütfen çeviriyi ekle',
          'MJS_SELECTOPTION': 'Lütfen bir seçenek seçin',
          'MJS_OPTIONADDED': 'Demografik doğru eklendi',
          'OPTIONDELETED': 'Demografik olarak başarıyla silindi',
          'RESPONSEOPTIONDELETED': 'Yanıt başarıyla kaldırıldı',
          'DEMOGRAPHICEXIST': 'Seçilen demografi zaten var',
          'AGREGADEMOGRAFICO': 'Daha fazla demografi eklemek için seçin',
          'MSJ_PRACTICEREQUIRED': 'Uygulama adı gerekmektedir!',
          'MSJ_DESCRIPTIONREQUIRED': 'Açıklama gerekmektedir!',
          'CARGANDO_PRACTICA': 'Pratik kaydediliyor, lütfen bekleyin...',
          'CARGANDO_DESCRIPCION': 'Açıklama kaydediliyor, lütfen bekleyin...',
          'ACTUALIZAR_OPCION': 'Yanıt güncelleniyor, lütfen bekleyin...',
          'REVISANDO_PRACTICAS': 'Uygulamalar kontrol ediliyor, lütfen bekleyin ...',




          'SELECCIONE': 'Ön izleme için bir dil seçiniz',
          'IDIOMAS_NOT_SELECTED': 'Çeviri için ek dilleri seçmediniz',
          'TRANSLATE_NOT': 'En azından bir uygulamanın adını ve açıklamasını yazmalısınız',
          'PLACEHOLDER': 'Dil',
          'DESC_TRANSLATE': 'Çeviri alıştırmasını girin',
          'DESC_TRANSLATE_DEMO': 'Yanıtın çevirisini girin',
          'DESC_TRANSLATE_FORALL': 'Açıklamanın çevirisini girin',
          'PRACTICE_TRANSLATE_REACTIVOS': 'İfadelerin çevirisini girin',
          'PRACTICE_TRANSLATE_ABIERTAS': 'Açık sorunun çevirisini girin',
          'PRACTICE_TRANSLATE_FORALL': 'Uygulama çevirisini girin',
          'PRACTICE_TRANSLATE_DEMO': 'Demografinin çevirisini girin',

          // 'IDIOMAS': {
          //     'Native': 'Nativo',
          //     'es': 'Español',
          //     'zh1': 'Chino Tradicional',
          //     'zh2': 'Chino Simplificado',
          //     'pt': 'Portugués',
          //     'en': 'Inglés'
          //   },
          // 'RESPUESTAS': {
          //     'Native': 'Nativo',
          //     'es':{'si': 'SÍ',
          //           'no':'NO',
          //           'casifalso':'Casi siempre es falso',
          //           'false': 'Frecuentemente es falso',
          //           'avecesfalse': 'A veces es falso / A veces es verdad',
          //           'casiverdad': 'Frecuentemente es verdad',
          //           'verdad': 'Casi siempre es verdad'},
          //     'zh1':{'si': '对','no':'没有',
          //           'casifalso':'卡西尔·辛普森·法斯特',
          //           'false': '基金会',
          //           'avecesfalse': '途径/途径',
          //           'casiverdad': '纪念馆',
          //           'verdad': '普通绿卡'},
          //     'zh2':{'si': '对','no':'没有',
          //           'casifalso':'卡西尔·辛普森·法斯特',
          //           'false': '基金会',
          //           'avecesfalse': '途径/途径',
          //           'casiverdad': '纪念馆',
          //           'verdad': '普通绿卡'},
          //     'pt':{'si': 'SI','no':'não',
          //           'casifalso':'Casi siempre es falso',
          //           'false': 'Freqüentemente é falso',
          //           'avecesfalse': 'A veces es falso / A veces es verdad',
          //           'casiverdad': 'Freqüentemente es verdad',
          //           'verdad': 'Casi siempre es verdad'},
          //     'en':{'si': 'YES','no':'NO',
          //           'casifalso':'It is almost always false',
          //           'false': 'It is often false',
          //           'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
          //           'casiverdad': 'It is often true',
          //           'verdad': 'It is almost always true'}
          //   },
            'STATUS': {
              'PEND': 'İşlemi tamamlayınız',
              'DONE': 'İşlem tamamlandı'
            },
            'TABLA': {
              'TITULOS': {
                'DEFAULT': 'Ana dil',
                'TRADUCCION': 'Çeviriler',
                'PREVIEW': 'Ön izleme'
              },
              'ENCABEZADOS': {
                'PRACT': 'Uygulama adı',
                'DESCR': 'Açıklama',
                'STT1': 'Soru 1',
                'STT2': 'Soru 2',
                'LANG': 'Dil'
              },
              'INPUTS': {
                'PRACT': 'Uygulama adını giriniz',
                'DESCR': 'Açıklama giriniz'
              }
            }
        },
        'ABIERTAS': {
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'TABS': {
            'TAB1': 'açık sorular',
            'TAB2': 'Çevirmek',
            'TAB3': 'Ön izleme',
          }
        },
        'ADICIONALES': {
          'FOCUS':{
            'ENVIO-AUTORIZACION':'Yetkilendirmeye gönderildi',
            'AUTORIZACION-OK':'Anketiniz yetkilendirildi, adımı tamamlamaya devam edin',

          },
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'TABS': {
            'QUESTIONS': 'Ek sorular',
            'TRANSLATE': 'Çeviriler',
            'PREVIEW': 'Ön izleme'
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN': 'Herhangi bir ek soru oluşturulmadı',
              'CON': 'Oluşturulmuş olan sorular:',
              // 'NOADICIONALES': 'Se eligió la opción sin preguntas adicionales',
              // 'CANCELNOADIC': 'Se canceló la opción sin preguntas adicionales',
              // 'ERROR': 'Ocurrió un error al realizar la operación'
            },
            'ACCIONES': {
              'ADD': 'Soru oluştur',
              'SIN': 'Bu anket ek sorular içermeyecek'
            },
            'WIZARD': {
              'NEW': 'Yeni soru',
              'TIPOTITU': 'Ek soru oluşturmak için burayı tıklayın',
              'TIPO': {
                'OPEN': 'Açık soru',
                'UNI': 'Tek seçimli soru',
                'MULT': 'Çoklu seçimli soru',
                'MULTLIKERT3-1': '3 likert ölçeğinde soru',
                'MULTLIKERT5-1': '5 likert ölçeğinde soru',
                'MULTLIKERT-MUL': 'Çoklu likert ölçeğinde soru',

              },
              'FORM': {
                'TIPO': 'Soru tipi',
                'TOOLTIP': {
                  'REMOVE': 'Bu soruyu sil'
                },
                'MENSAJES': {
                  'BORRAR': 'Bu ek soruyu silmek istiyor musunuz?',
                  'PREG_OK': 'Soru başarıyla kaydedildi',
                  'PREG_ERR': 'Soruyu kaydederken bir hata oluştu',
                  'PREG_MOD_OK': 'Soru doğru değiştirildi',
                  'PREG_MOD_ERR': 'Soruyu değiştirirken bir hata oluştu',
                  'OPC_OK': 'Cevap seçeneği başarıyla kaydedildi',
                  'OPC_ERR': 'Cevap seçeneği kaydedilirken bir hata oluştu',
                  'OPC_MOD_OK': 'Cevap seçeneği doğru değiştirildi',
                  'OPC_MOD_ERR': 'Cevap seçeneği değiştirilirken bir hata oluştu',
                  'PREG_DEL_OK': 'Soru başarıyla silindi',
                  'PREG_DEL_ERR': 'Soruyu silerken bir hata oluştu',
                  'OPC_DEL_OK': 'Cevap seçeneği başarıyla silindi',
                  'OPC_DEL_ERR': 'Cevap seçeneği silinirken bir hata oluştu'
                },
                'BOTONES':{
                  'SI': 'Evet',
                  'NO': 'Hayır'
                }
              },
              'ABIERTA': {
                'TITULO': 'Yeni açık soru',
                'ACCION': 'Soru metnini girin',
                'ERROR': 'Soru metnini girmediniz'
              },
              'MULTI':{
                'TITULOSING': 'Yeni tek seçimli soru',
                'TITULOMULT': 'Yeni çoklu seçimli soru',
                'TITULOLIKERT3': 'Likert ölçeğinde yeni soru: 3',
                'TITULOLIKERT5': 'Likert ölçeğinde yeni soru: 5',
                'TITULOLIKERTSIMPLE': 'Yeni basit likert ölçekli soru',
                'ACCION': 'Soruyu girin',
                'ERROR': 'Soruyu girmediniz',
                'MENSAJES': {
                  // 'BORRAR': '¿Desea borrar esta opción de respuesta?',
                  // 'SINPREG': 'No puede introducir opciones hasta que introduzca el texto de la pregunta',
                  // 'SINANTE': 'No puede introducir el texto de esta opción hasta que introduzca el texto de la opción anterior'
                  'WARN-2-1': 'Yalnızca 2 cevap seçeneği girebilirsiniz',
                  'WARN-3-1': 'Yalnızca 3 cevap seçeneği girebilirsiniz',
                  'WARN-5-1': 'Yalnızca 5 cevap seçeneği girebilirsiniz',
                  'WARN-NO-NUMBER': 'Yalnızca sayı girebilirsiniz',
                  'ETIQUET-VALOR':'Değer',
                },
                'OPCIONES': {
                  'TITU': 'Cevap seçenekleri',
                  'INPUT': {
                    'TITU': 'Cevap seçeneği',
                    'ERROR': 'Cevap seçeneğini girmediniz'
                  }
                },
                'TOOLTIP': {
                  'ADD': 'Seçeneği ekleyin',
                  'MOVE': 'Seçeneği taşı',
                  'REMOVE': 'Bu seçeneği kaldır'
                }
              }
            }
          },
          'TRADUCCIONES': {
            // 'TITULO': 'Seleccione un idioma para introducir los textos de traducción',
            // 'TITULOALTERNO': 'No seleccionó idiomas adicionales en la sección "Idiomas"',
            'NOTYET': 'Çeviri henüz tamamlanmadı.',
            'MAIN': 'Ana dil',
            'INPUT': {
              'NEW': 'Soru çevirisini girin',
              'ERROR': 'Soru çevirisini girmediniz!',
              'NEWOPC': 'Cevap seçeneği çevirisini girin',
              'ERROROPC': 'Çeviri metni girilmedi!'
            },

            'MENSAJES': {
            //   'PREG_OK': 'El texto de traducción se almacenó correctamente',
            //   'PREG_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            //   'PREG_MOD_OK': 'El texto de traducción se actualizó correctamente',
            //   'PREG_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción',
            //   'OPC_NOPREG': 'No se puede almacenar el texto de traducción de la opción de respuesta sin que introduzca primero el texto de la pregunta',
            //   'OPC_OK': 'El texto de traducción se almacenó correctamente',
            //   'OPC_ERR': 'Ocurrió un error al almacenar el texto de traducción',
            //   'OPC_MOD_OK': 'El texto de traducción se actualizó correctamente',
            //   'OPC_MOD_ERR': 'Ocurrió un error al actualizar el texto de traducción'
            'TRADUC_PREGUNT':'Sorunun çevirisi kaydediliyor',
            'TRADUC_MOD_PREGUNT':'Sorunun çevirisi güncelleniyor',
            'TRADUC_OPC':'Seçeneğin çevirisi kaydediliyor',
            'TRADUC_MOD_OPC':'Seçeneğin çevirisi güncelleniyor',
            'VALOR_OK':'Seçeneğin değeri doğru şekilde kaydediliyor',
            'VALOR_MOD_OK':'Seçeneğin değeri doğru şekilde güncellendi',
            },
            'COMPLETE': 'Çeviri tamamlandı '
          },
          'PREVIEW': {
          //   'TITULO': 'Seleccione un idioma para mostrar las traducciones de las preguntas adicionales',
          //   'LOADING': 'Cargando datos',
          //   'INPUT': {
          //     'RESPABIERTA': 'Escriba su respuesta',
          //     'ERRORABIERTA': '¡No ha escrito su respuesta!',
          //     'ELIGELANG': 'Elija un idioma'
          //   }

          'TITULO': 'Ek soru çevirilerini göstermek için bir dil seçin',
          'SINPREV': 'Seçilen dil için çeviri yok',
            'LOADING': 'Veri yükleniyor',
            'INPUT': {
              'RESPABIERTA': 'Cevabını yaz',
              'ERRORABIERTA': 'Cevabınızı yazmadınız!',
              'ELIGELANG': 'Bir dil seçin'
            },
            'HELP': {
              'SINGLE': 'Bu soruda sadece bir seçenek seçebilirsiniz',
              'MULTI': 'Bu soruda birden fazla seçenek seçebilirsiniz',
              'FALTA': 'Çeviri metni girilmedi!'
            }



          }
        },
        'COLABORADORES': {
          'STATUS': {
            'PEND': 'İşlemi tamamlayınız',
            'DONE': 'İşlem tamamlandı'
          },
          'STATUSBAR': {
            'NOBD': 'Katılımcı verisini yüklemediniz',
            'PROCES': 'Katılımcı verisi henüz kaydedilmedi',
            'ERROR': 'Yüklenen dosyada hata bulundu',
            'OK': 'Katılımcı verisi doğru şekilde kaydedildi'
          },
          'CARD_BD': {
            'TITULO': 'Bilgi',
            'NUMCOLABS': 'Ortak çalışan sayısı',
            'FECHA': 'Son yükleme tarihi: ',
            'TITULO_PRE': 'Yükleme geçmişi:',
            'TITULO_PRE_2': 'kullanıcılar',
            'ACCIONES': 'İşlemler',
            'WANNADO': 'Yapmak istediğiniz işlem?',
            'BOTONES': {
              'DESCARGA': 'Katılımcı verisini indir',
              'ELIMINA': 'Katılımcı verisini sil',
              'VER': 'Katılımcı listesini görün'
            }
          },
          'CARD_NOBD': {
            'TITULO': 'CULTURAL GO® platformuna katılımcı verisini yüklemek için bu adımları izleyiniz',
            'PASOS': {
              '1': 'Katılımcı verisi şablonunu indirin',
              '2': 'Şablonda size sağlanmış olan kolonlara ilgili katılımcı verisini giriniz',
              '3': 'Katılımcı verinizi girerek hazırladığınız şablon dosyasını yükleyiniz '
            },
            'TOOLTIP': 'Bu dosya veri doğrulama makroları içerir',
            'FILE': 'Ortak çalışanlar Listesi Şablon dosyası'
          },
          'CARD_NOERR': {
            'TITULO': 'Bilgi',
            'NUMCOLABS': 'Yüklenen dosyadaki katılımcı sayısı',
            'FILENAME': 'Dosya adı',
            'GUARDAR': 'Bu bilgiyi kaydetmek istiyor musunuz?',
            'BOTONES': {
              'SI': 'Evet',
              'NO': 'değil'
            }
          },
          'CARD_ERRFND': {
            'TITULO': 'Bilgi',
            'ROWS_OK': 'Doğru girilen satır sayısı',
            'ROWS_NOTOK': 'Hata içeren satır sayısı',
            'MOREINFO': '* Detaylı hata listesini aşağıda bulabilirsiniz',
            'FILENAME': 'Dosyanın adı',
            'GUARDAR': 'Yüklenen bilgi sistem tarafından kaydedilemiyor',
            'DELETE': 'Dosyayı sil'
          },
          'CARD_ERRLIST': {
            'TITULO': {
              '1': 'Hatalı satırlar: ',
              '2': 'Toplam hata sayısı: '
            },
            'INFO': {
              'ROW': 'Sira ',
              'ERRNUM': 'Hata sayısı: ',
              'SHOW': 'Bu satır hatalarını göstermek için buraya tıklayın'
            },
            'DETALLE': {
              'TIPO': 'Hatanın türü',
              'DESCR': 'Açıklama',
              'COLUMNA': 'Sütun',
              'DATO': 'Yanlış veri'
            },
            'ERRORES': {
              'alfabetica': 'Alfabetik geçersiz veri',
              'alfanumerica': 'Alfanümerik geçersiz veri',
              'numerica': 'Sayısal geçersiz veri',
              'email': 'E-posta geçersiz sözdizimi',
              'vacio': 'Boş hücre',
              'columna': 'Bilinmeyen sütun',
              'catSurvey': 'Bilinmeyen veri',
              'repetido': 'Tekrarlanan veriler',
              'sameKey': 'Aynı patron anahtarı',
              'noCeo': 'CEO bulunamadı',
              'bosskeyNotFnd': 'Boss anahtarı mevcut değil',
              'continuidad': 'Seviyelerde süreklilik',
              'nivelRepetido': 'Tekrarlanan bilgiler',
              'multiceo': 'Çoklu CEO',
              'age': 'Yanlış doğum yılı',
              'seccionSinUsar': 'Özel bölüm anahtarı kullanılmadı',
              'date': 'Geçersiz tarih biçimi',
              'listOption': 'Yanlış bilgi',
              'dateFuture': 'Tarihe izin verilmiyor'
            },
            'DESCRIPCION': {
              'alfabetica': 'Bilgi bir veya daha fazla geçersiz karakter içeriyor. Sadece alfabetik karakterler (A - Z) ve sonraki özel karakterler: [(). , : -] izin verilir',
              'alfanumerica': 'Bilgi bir veya daha fazla geçersiz karakter içeriyor. Sadece alfabetik karakterler (A - Z), sayısal (0 - 9) ve sonraki özel karakterler: [(). , : -] izin verilir',
              'numerica': 'Bilgi bir veya daha fazla geçersiz karakter içeriyor. Yalnızca sayısal karakterlere (0 - 9) izin verilir',
              'email': 'Bilgiler doğru e-posta sözdizimine sahip değil (mail@domain.com)',
              'vacio': 'Hücrenin bilgisi yok. Bu sütun zorunludur.',
              'columna': 'Sütun CulturalGO tarafından sağlanan şablona ait değil',
              'catSurvey': 'Hücre bilgisi, platformun Demografik bölümüne girilen seçeneklerle eşleşmiyor',
              'repetido': 'Bu hücre, aynı sütundaki başka bir hücreden tekrarlanan bilgileri içeriyor. Bu sütunda tekrarlanan verilere izin verilmiyor.',
              'sameKey': 'Bu satır, bu sütunlarda aynı bilgilere sahiptir: "ÇALIŞAN NUMARASI" ve "DOĞRUDAN BOSS NUMARASI", buna izin verilmez',
              'noCeo': 'Ortak çalışanlar listesinde CEO bilgisi bulunamadı, devam etmek için ÇALIŞAN NUMARASI ile \'0\' olarak belirtilmelidir',
              'bosskeyNotFnd': 'Bu hücrede belirtilen patronun anahtarı, listedeki herhangi bir ortak çalışanla ilişkili bulunamadı',
              'continuidad': 'Bu hücredeki seviyelerin devamlılığı kesintiye uğradı, seviyeler sürekli olmalı',
              'nivelRepetido': 'Bu hücredeki bilgiler, önceki seviyeye karşılık gelen ile tekrarlandı, buna izin verilmiyor',
              'multiceo': 'CEO olarak belirtilen birden fazla ortak çalışan bulundu, dosyada CEO olarak belirtilen yalnızca bir ortak çalışanın bulunmasına izin verildi ',
              'age': 'Girilen doğum yılı dört haneli olmalıdır',
              'seccionSinUsar': 'Ortak çalışanlar listesinde kullanılmayan en az bir özel bölüm anahtarı bulundu. Tüm özel bölüm anahtarlarının en az bir ortak çalışan tarafından kullanılması gerekir',
              'date': 'Girilen bilgiler doğru tarih formatına sahip değil',
              'listOption': 'Girilen bilgiler, şablon tarafından sağlanan seçeneklerin hiçbiriyle eşleşmiyor. Bu hücrede varsayılan seçeneklerden yalnızca birine izin verilir',
              'dateFuture': 'Hücreye girilen tarih, geçerli günden sonraki bir tarihe karşılık gelir. Yalnızca geçerli günden önceki bir tarihin girilmesine izin verilir'
            }
          },
          'CARD_LOAD': {
            'CARGA': {
              'TITULO': 'Yükleniyor',
              'INFO': 'Veri inceleniyor, lütfen bekleyiniz'
            },
            'GUARDA': {
              'TITULO': 'Tasarruf',
              'INFO': 'Bilgileri sisteme kaydetmek, kaydetme işlemi tamamlanıncaya kadar bu ekranda kalın.'
            },
          },
          'MENSAJES': {
            'GUARDA_1': '',
            'GUARDA_2': ' katılımcı için veri kaydedilecektir, onaylıyor musunuz?',
            'GUARDADO': 'Katılımcı verisi başarıyla kaydedildi',
            'NODELETE':'E-postalar ortak çalışanlarınıza gönderildiyse veri tabanını silemezsiniz',
            'GUA_ERR': 'Bilgi depolanırken bir hata oluştu. Daha sonra tekrar deneyin',
            'DELETE_1': 'Bilgilerini silmek için onaylıyor musunuz? ',
            'DELETE_2': ' işbirlikçiler?',
            'DEL_OK_1': 'Bilgi ',
            'DEL_OK_2': ' ortak çalışanlar başarıyla silindi',
            'DEL_ERR': 'Ortak veri tabanını silerken bir hata oluştu. Daha sonra tekrar deneyin',
            'DEL_ERR_EMA_SEN': 'E-postalar gönderildiği için bu işlem yapılamıyor',
            'DELFILE': 'Katılımcı veri dosyası başarıyla silindi',
            'EXCEL': 'Excel dosyası oluşturuluyor, lütfen bekleyin',
            'EXTMAL': 'Seçilen dosya doğru formatta değil. Sadece CulturalGO tarafından sağlanan şablon dosyasının yüklenmesine izin verilir',
            'NOROWS': 'Seçilen dosyada hiç kayıt yok',
            'VACIO': 'Seçilen dosya boş veya ortak çalışanlar bilgileri ilk sayfada değil',
            'VERSIONANTERIOR': 'Seçilen dosya, ortak çalışanlar listesinin önceki bir sürümüne karşılık geliyor, en son sürümü indirin, ortak çalışanlarınızın bilgilerini o dosyaya yükleyin ve listeyi yeniden yükleyin',
            'BROKERINCORRECTO': 'Seçilen dosya, şirketin ait olduğu brokerın sürümüne uymuyor, şablonu tekrar indirin, ortak çalışanlarınızın bilgilerini o dosyaya yükleyin ve listeyi yeniden yükleyin.',
            'BOTONES': {
              'SI': 'Evet',
              'NO': 'değil'
            }
          },
          'EXCELINFO': {
            'HOJA': 'Ortak çalışanlar verileri',
            'TITULO': 'Ortak çalışan veritabanı',
            'AUTOR': 'CulturalGO',
            'ASUNTO': 'Platformdan indirildi'
          },
          'UPLOAD': 'Katılımcı verisini incelemek için tıklayınız',
          'REMOVE': 'Veri yükünü sil',
          'SEND': 'Veri tabanına gönder',
          'PROCESO': {
            'STP1': 'Katılımcı veri tabanı analiz ediliyor',
            'STP2': 'Katılımcı verisi kaydediliyor'
          },
          'ALERT_COLAB':'Bu adım tamamlandı olarak işaretlendikten sonra kullanıcılar ankete yansıtılacaktır.',
          'MODAL_ERROR': {
            'TITULO': 'Dosyada bulunan hatalar',
            'TOTAL_ERRORES_1': 'Dosyada bulunan hatalar',
            'TOTAL_ERRORES_2': 'Dosyada <b> 100\'den fazla </b> hata bulundu',
            'INFO_1': 'Belirli hataların miktarı ve türü aşağıda ayrıntılı olarak gösterilmiştir.',
            'INFO_2': '<b> NOT: </b> işlem yalnızca dosyada hata yoksa devam edebilir, bu pencere kapatıldığında işlem yeniden başlatılacaktır. Dosyada gerekli düzeltmeleri yapın ve yeniden yükleyin',
            'TABLA_RESUMEN': {
              'TIPO': 'Hata türü',
              'TOTAL': 'Toplam hata',
              'ACCIONES': 'Hareketler',
              'MASINFO': 'Daha fazla bilgi',
              'VERMAS': 'Hataları görüntüle'
            },
            'TABLA_LISTA': {
              'TOTAL_1': 'Görüntülenen hatalar',
              'TOTAL_2': 'Hatalar görüntülenmiyor',
              'INFO': 'Gösterilmeyen hatalar, gösterilenlere benzer özelliklerdedir',
              'FILA': 'Sıra',
              'COLUMNA': 'Kolon',
              'DATO': 'Yanlış veri'
            },
            'BOTONES': {
              'REGRESAR': 'Geri gitmek',
              'CONTINUAR': 'Devam et'
            }
          }
        }
      }
    }
};
